export default {
  'prop.key': {
    ko: '프로퍼티 키',
    ja: 'プロパティキー',
    en: 'Property key',
    cn: '',
  },
  'prop.value': {
    ko: '프로퍼티 값',
    ja: 'プロパティ値',
    en: 'Property value',
    cn: '',
  },
  'prop.modify': {
    ko: '프로퍼티 수정',
    ja: 'プロパティ修正',
    en: 'Modifying property',
    cn: '',
  },
  'prop.ph.key': {
    ko: '키 조건 입력',
    ja: 'キー条件を入力',
    en: 'Enter a key filter',
    cn: '',
  },
  'prop.ph.desc': {
    ko: '설명 조건 입력',
    ja: '説明条件を入力',
    en: 'Enter a description filter',
    cn: '',
  },
  'prop.desc': {
    ko: '프로퍼티 설명',
    ja: 'プロパティ説明',
    en: 'Property description',
    cn: '',
  },
  'prop.modify.confirm': {
    ko: '프로퍼티를 수정하시겠습니까?',
    ja: 'プロパティを修正しますか？',
    en: 'Do you modify the property?',
    cn: '',
  },
};
